// src/pages/ForgotPassword.js - Page mot de passe oublié moderne
import React, { useState } from 'react';
import { supabase } from '../supabaseClient';
import { Link } from 'react-router-dom';
import './AuthPages.css';

function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(null);
  const [emailSent, setEmailSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage(null);
    setLoading(true);

    try {
      const { error } = await supabase.auth.resetPasswordForEmail(email, {
        redirectTo: `${process.env.REACT_APP_FRONTEND_URL}/reset-password`,
      });

      if (error) {
        setMessage({ type: 'error', text: error.message });
      } else {
        setEmailSent(true);
      }
    } catch (err) {
      setMessage({ type: 'error', text: 'Une erreur est survenue. Veuillez réessayer.' });
    } finally {
      setLoading(false);
    }
  };

  // Écran de succès après envoi
  if (emailSent) {
    return (
      <div className="auth-container">
        <div className="auth-card">
          <div className="success-screen">
            <div className="success-icon">📧</div>
            <h2>Email envoyé !</h2>
            <p>
              Un lien de réinitialisation a été envoyé à<br />
              <strong>{email}</strong>
            </p>
            <p style={{ fontSize: '0.9rem', color: '#64748b', marginTop: '1rem' }}>
              Vérifiez votre boîte de réception et vos spams.<br />
              Le lien expire dans 24 heures.
            </p>
          </div>
          
          <div className="auth-footer">
            <Link to="/connexion-eleve">← Retour à la connexion</Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-container">
      <div className="auth-card">
        {/* Header */}
        <div className="auth-header">
          <div className="auth-icon">🔐</div>
          <h1>Mot de passe oublié ?</h1>
          <p>Entrez votre email pour recevoir un lien de réinitialisation</p>
        </div>

        {/* Message d'erreur */}
        {message && (
          <div className={`auth-message ${message.type}`}>
            <span className="message-icon">
              {message.type === 'error' ? '❌' : '✅'}
            </span>
            <span>{message.text}</span>
          </div>
        )}

        {/* Formulaire */}
        <form onSubmit={handleSubmit} className="auth-form">
          <div className="form-group">
            <label htmlFor="email">Adresse email</label>
            <div className="input-wrapper">
              <span className="input-icon">📧</span>
              <input
                id="email"
                type="email"
                placeholder="votre@email.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                autoFocus
              />
            </div>
          </div>

          <button type="submit" className="auth-btn" disabled={loading || !email}>
            {loading ? (
              <>
                <span className="spinner">⏳</span>
                Envoi en cours...
              </>
            ) : (
              <>
                📤 Envoyer le lien
              </>
            )}
          </button>
        </form>

        {/* Footer */}
        <div className="auth-footer">
          <Link to="/connexion-eleve">← Retour à la connexion</Link>
        </div>
      </div>
    </div>
  );
}

export default ForgotPassword;
